/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], () => {

	class ArrayUtils {
		static isArrayInArray(master, sub) {
			if ( Array.isArray(master) && Array.isArray(sub) && sub.length > 0 && sub.length <= master.length) {
				for ( let i = 0; i < master.length; i++ ) {
					if ( sub[0] === master[i] ) {
						let j = 0;
						for ( ; j < sub.length; j++ ) {
							if ( sub[j] !== master[j+i] ) {
								break;
							}
						}
						if ( j ===  sub.length) {
							return true;
						}
					}
				}
			}
			return false;
		}
	}
	return ArrayUtils;
});